let dirPath = 'static/games/page017_game1';

let configGame = {
  removeInCorrects: true,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  removeAllFromBadTarget: true,
  rulesGame: {
    itemsGarbage: [{ idGroup: 'source', itemsConfig: { block: false, shuffle: false } }],
    itemsConfig: {
      block: true,
      shuffle: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 't02',
        idItem: 't02',
        itemsConfig: { block: true, shuffle: true },
        items: [
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '00', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '01', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '02', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '03', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '04', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '05', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '06', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '07', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
          {
            idGroup: 't02',
            idItem: 't02',
            itemsConfig: { shuffle: true },
            items: [{ idGroup: 'source', idItem: '08', correct: [{ idGroup: 't02', idItem: 't02' }] }],
          },
        ],
      },
    ],
  },
  layout: {
    groups: [
      {
        idGroup: 't02',
        background: {
          image: { src: dirPath + '/img/20.png' },
        },
        positions: {
          type: 'absolute',
          autoFit: true,
          pos: { x: 0, y: 0, height: 765, width: 800 },
        },
        items: [
          {
            id: 't02',
            background: {
              color: 'rgba(47,87,144,1)',
              // color: 'rgba(255,0,0,1)',
            },
            positions: { pos: { x: 210, y: 170, width: 400, height: 260 } },
          },
        ],
      },
      {
        idGroup: 'source',
        itemsConfig: {
          positions: { pos: { height: 160, width: 81 } },
          background: {
            color: 'transparent',
            text: { size: '27px', textAlign: 'center', textBaseline: 'middle', color: 'black', lineWidth: 380 },
          },
        },
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 1500, y: 0 },
            { x: 1500, y: 170 },
            { x: 1500, y: 170 + 170 },
            { x: 1500, y: 170 + 170 + 170 },
            { x: 1500, y: 170 + 170 + 170 + 170 },
            { x: 1200, y: 0 },
            { x: 1200, y: 170 },
            { x: 1200, y: 170 + 170 },
            { x: 1200, y: 170 + 170 + 170 },
            { x: 900, y: 0 },
            { x: 900, y: 170 },
            { x: 900, y: 170 + 170 },
            { x: 900, y: 170 + 170 + 170 },
            { x: 900, y: 170 + 170 + 170 + 170 },
          ],
        },
        items: [
          {
            id: '00',
            positions: { pos: { width: 133 } },
            background: { image: { src: dirPath + '/img/00.png' } },
          },
          {
            id: '01',
            positions: { pos: { width: 92 } },
            background: { image: { src: dirPath + '/img/01.png' } },
          },
          {
            id: '02',
            positions: { pos: { width: 101 } },
            background: { image: { src: dirPath + '/img/02.png' } },
          },
          {
            id: '03',
            positions: { pos: { width: 99 } },
            background: { image: { src: dirPath + '/img/03.png' } },
          },
          {
            id: '04',
            positions: { pos: { width: 99 } },
            background: { image: { src: dirPath + '/img/04.png' } },
          },
          {
            id: '05',
            positions: { pos: { width: 115 } },
            background: { image: { src: dirPath + '/img/05.png' } },
          },
          {
            id: '06',
            positions: { pos: { width: 160 } },
            background: { image: { src: dirPath + '/img/06.png' } },
          },
          {
            id: '07',
            positions: { pos: { width: 163 } },
            background: { image: { src: dirPath + '/img/07.png' } },
          },
          {
            id: '08',
            positions: { pos: { width: 109 } },
            background: { image: { src: dirPath + '/img/08.png' } },
          },
          {
            id: '10',
            positions: { pos: { width: 265 } },
            background: { image: { src: dirPath + '/img/10.png' } },
          },
          {
            id: '11',
            positions: { pos: { width: 160 } },
            background: { image: { src: dirPath + '/img/11.png' } },
          },
          {
            id: '12',
            positions: { pos: { width: 160 } },
            background: { image: { src: dirPath + '/img/12.png' } },
          },
          {
            id: '13',
            positions: { pos: { width: 201 } },
            background: { image: { src: dirPath + '/img/13.png' } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  realHeight: 850,
  realWidth: 1800,
  configGame: configGame,
  mainImage: {
    imagePath: dirPath + '/img/background.jpg',
  },
};

export default dataConfig;
